import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { Radio } from './Radio';

type Props = Omit<React.ComponentProps<typeof Radio>, ''> & {
  noButtonStyle?: boolean;
};

export const RadioButton: React.FC<Props> = ({
  className,
  noButtonStyle,
  ...other
}) => {
  let cls = classNames(className, Classes.RADIO, Classes.RADIO_BUTTON, {
    [Classes.RADIO_BUTTON_NO_BUTTON]: noButtonStyle,
  });

  return <Radio className={cls} {...other} />;
};
